<template>
    <div class="qksm qksm10">
        <h4>九、国有资本经营预算财政拨款支出决算情况说明</h4>
        <p v-if="num(qksm['国有资本经营预算']) == 0 && T9.总计 == 0">
            本{{ $parent.typeText }}没有使用国有资本经营预算安排的支出。
        </p>
        <div class="nogap" v-else>
            <p>
                2021年度国有资本经营预算财政拨款支出年初预算为
                <reason type="money" classname="qksm money beginYear" name="国有资本经营预算" v-model:value="qksm['国有资本经营预算']"></reason>
                万元，
                支出决算为{{ isMoney(T9.总计) }}万元，
                <template v-if="num(qksm['国有资本经营预算']).toFixed(2) == num(T9.总计).toFixed(2)">
                    完成年初预算的100%，决算数与年初预算数基本持平。
                </template>
                <template v-else>
                    <template v-if="num(qksm['国有资本经营预算']) != 0">
                        完成年初预算的{{ calcRatio(T9.总计, qksm['国有资本经营预算']) }}。
                    </template>
                    决算数{{ num(T9.总计) > num(qksm['国有资本经营预算']) ? "大于" : "小于" }}年初预算数的主要原因是
                    <reason type="textarea" classname="qksm widest because" name="国有资本支出原因"
                        v-model:value="qksm['国有资本支出原因']"></reason>
                </template>
                <template v-if="T9.items.length > 0">
                    其中：
                </template>
            </p>
            <p v-for="(item, idx) in T9.items">
                {{ T9.items.length > 1 ? "（" + intToChinese(idx + 1) + "）" : "" }}{{ item.lei }}{{ item.kuan }}{{ item.xiang }}。年初预算为
                <reason type="money" classname="qksm money beginYear" :name="item.code + '国有资本'"
                    v-model:value="qksm[item.code + '国有资本']"></reason>万元，支出决算为{{ isMoney(item.value) }}万元，
                    <span v-if="num(qksm[item.code + '国有资本'])==0">年初无预算。</span>
                <template v-if="num(qksm[item.code + '国有资本']).toFixed(2) == num(item.value).toFixed(2)">
                    完成年初预算的100%，决算数与年初预算数基本持平。
                </template>
                <template v-else>
                    <template v-if="num(qksm[item.code + '国有资本']) != 0">
                        完成年初预算的{{ calcRatio(item.value, qksm[item.code + '国有资本']) }}。
                    </template>
                    决算数{{ num(item.value) > num(qksm[item.code + '国有资本']) ? "大于" : "小于" }}年初预算数主要原因是
                    <reason type="textarea" classname="qksm widest because" :name="item.code + '国有资本原因'"
                        v-model:value="qksm[item.code + '国有资本原因']"></reason>
                </template>
            </p>
        </div>
    </div>
</template>
<script>
import reason from "@/components/reason.vue";
export default {
    name: "qksm10",
    props: {
        T9: {
            type: Object,
            default: "",
        },
    },
    data() {
        var qksm = this.$store.state.divData.qksm;
        this.$store.state.divData.qksm['国有资本经营预算'] = this.num(this.$store.state.divData.qksm['国有资本经营预算'])
        if (qksm['T9总计去年'])
            this.T9['总计_last'] = qksm['T9总计去年'];
        return {
            isPdf: this.$parent.isPdf,
            qksm: qksm,
        }
    },
    components: {
        reason,
    },
};
</script>
